export const ACCEPTED_IMAGE_FORMATS_ARRAY = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/webp",
    "image/bmp",
  ];
  
  export const ACCEPTED_IMAGE_FORMATS = ACCEPTED_IMAGE_FORMATS_ARRAY.join(", ");